'use client';

import { css } from '@linaria/core';

export const name = css`
  font-weight: 600;
`;

export const root = css`
  display: flex;
  gap: 1rem;
  flex-wrap: nowrap;
  height: 250px;
  a {
    aspect-ratio: 9/14;
    border-radius: 0.5rem;
    width: 160px;
    overflow: hidden;
    position: relative;
    .${name} {
      position: absolute;
      top: 0.5em;
      color: white;
      font-size: 16px;
      left: 0.5em;
      right: 0.5em;
      &:before {
        content: ' ';
        position: absolute;
        inset: -0.5em;
        background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0));
        z-index: 0;
      }
      > span {
        position: relative;
        z-index: 10;
      }
    }
  }
`;

export const seeMore = css`
  background-color: white;
  position: relative;
  span {
    color: white;
    font-weight: 600;
    z-index: 1;
    position: absolute;
    inset: 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  &::after {
    position: absolute;
    inset: 0;
    content: ' ';
    background: rgba(0, 0, 0, 0.5);
  }
`;

export const seeMoreGrid = css`
  position: absolute;
  inset: 0.5rem;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-auto-rows: 1fr;
  gap: 0.5rem;
  img {
    aspect-ratio: 9/14;
    display: block;
    object-fit: cover;
    width: 100%;
    height: 100%;
    border-radius: 0.5rem;
  }
`;
